import { useState, useEffect, useCallback } from 'react';
import PushSetup from './PushSetup';
import { pushSupported } from '../utils/pushFirebase';
import { api } from '../api/client';

/** One-time enrollment banner — hides automatically after user enables push */
export default function PushEnableBanner({ lang = 'ar' }) {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('push_banner_dismiss') === '1');

  const load = useCallback(async () => {
    try {
      const data = await api.getPushStatus();
      setStatus(data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!pushSupported() || dismissed || !status) return null;
  if (!status.enabled || status.subscribed) return null;
  if (typeof Notification !== 'undefined' && Notification.permission === 'denied') return null;

  return (
    <div style={styles.banner}>
      <div style={styles.header}>
        <strong style={{ fontSize: 13 }}>
          {lang === 'ar' ? 'فعّل إشعارات النظام على هذا الجهاز' : 'Enable system notifications'}
        </strong>
        <button type="button" style={styles.dismiss} aria-label="Dismiss" onClick={() => {
          sessionStorage.setItem('push_banner_dismiss', '1');
          setDismissed(true);
        }}>✕</button>
      </div>
      <PushSetup lang={lang} compact />
    </div>
  );
}

const styles = {
  banner: {
    background: 'linear-gradient(135deg, #EDE7F6 0%, #fff 100%)',
    border: '1px solid #D1C4E9',
    borderRadius: 12,
    padding: '12px 14px 4px',
    marginBottom: 12,
  },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 },
  dismiss: {
    background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: 18, padding: 0,
  },
};
